import React, { useEffect, createElement } from 'react';
import { CountdownTimer } from './CountdownTimer';
import { SocialProofPopup } from './SocialProofPopup';
import { CTAButton } from './CTAButton';
import { CheckCircle2, XCircle, Lock, ShieldCheck, ChevronRight, AlertTriangle, Zap, Brain, Clock, Smartphone, BookOpen, Gift } from 'lucide-react';
const PURCHASE_LINK = 'https://fegion.shop/cart/46060572835979:1';
export function SalesPage() {
  useEffect(() => {
    // Force scroll to top on page load
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
    // Also handle hash-based navigation prevention on initial load
    if (window.location.hash) {
      window.history.replaceState(null, '', window.location.pathname);
    }
  }, []);
  useEffect(() => {
    // Initialize Meta Pixel directly via script injection
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '904978025482552');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // Add noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=904978025482552&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-purple-200" data-id="element-7">
      <CountdownTimer data-id="element-8" />
      <SocialProofPopup data-id="element-9" />

      {/* SECTION 1 - HERO */}
      <section className="pt-12 pb-16 px-4 max-w-5xl mx-auto text-center" data-id="element-10">
        <div className="inline-block bg-purple-100 border border-purple-200 rounded-full px-6 py-2 mb-8" data-id="element-11">
          <p className="text-purple-800 font-semibold text-sm md:text-base" data-id="element-12">
            🟣 Para personas que sienten que el celular controla su tiempo, su
            atención y su energía… y quieren recuperar el control de su mente.
          </p>
        </div>

        <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-gray-900 tracking-tight mb-4 uppercase text-center" data-id="element-13">
          <span className="block" data-id="element-14">🧠 MEGA PACK</span>
          <span className="block text-purple-500" data-id="element-15">RESET DE DOPAMINA</span>
        </h1>

        <h2 className="text-2xl md:text-3xl font-bold text-gray-600 mb-8" data-id="element-16">
          Sistema práctico para romper la adicción al celular y recuperar tu
          concentración en 14 días
        </h2>

        <a href="#compra" className="block cursor-pointer hover:opacity-95 transition-opacity mb-10" data-id="element-17">
          <img src="https://cdn.magicpatterns.com/uploads/rzEnN65CyTDuQo6YYdzGax/mockup_page-0001.jpg" alt="Mega Pack Reset de Dopamina" className="w-full max-w-3xl mx-auto rounded-xl shadow-2xl" data-id="element-18" />
        </a>

        <div className="max-w-3xl mx-auto text-lg md:text-xl text-gray-700 space-y-4 mb-10 font-medium" data-id="element-19">
          <p data-id="element-20">Si sentís que el celular te roba horas todos los días…</p>
          <p data-id="element-21">Si abrís redes sociales sin darte cuenta…</p>
          <p data-id="element-22">
            Si empezás revisando un mensaje y terminás viendo videos durante 40
            minutos…
          </p>
          <p className="font-bold text-gray-900 text-xl md:text-2xl mt-6" data-id="element-23">
            Trabajar más duro no va a solucionarlo.
          </p>
          <p className="font-bold text-red-600 text-xl md:text-2xl mt-2" data-id="element-24">
            Porque el problema no es falta de disciplina.
          </p>
          <p className="mt-4" data-id="element-25">
            <span className="font-bold text-purple-600 text-2xl md:text-3xl" data-id="element-26">
              El problema es dopamina digital.
            </span>
          </p>
        </div>

        <CTAButton text="👉 SÍ, QUIERO EMPEZAR MI RESET AHORA" data-id="element-27" />

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 mt-6 font-semibold text-gray-700" data-id="element-28">
          <span className="flex items-center gap-2" data-id="element-29">
            <CheckCircle2 className="text-green-500 w-5 h-5" data-id="element-30" /> Acceso inmediato
          </span>
          <span className="flex items-center gap-2" data-id="element-31">
            <CheckCircle2 className="text-green-500 w-5 h-5" data-id="element-32" /> Implementación
            en 14 días
          </span>
          <span className="flex items-center gap-2" data-id="element-33">
            <CheckCircle2 className="text-green-500 w-5 h-5" data-id="element-34" /> Sistema paso a
            paso
          </span>
        </div>
      </section>

      {/* SECTION 2 - PAIN POINTS */}
      <section className="bg-gray-50 py-16 px-4 border-y border-gray-200" data-id="element-35">
        <div className="max-w-4xl mx-auto" data-id="element-36">
          <h3 className="text-3xl md:text-4xl font-bold text-center mb-10" data-id="element-37">
            Déjame hacerte una pregunta honesta…
          </h3>

          <div className="space-y-6 text-lg md:text-xl font-medium bg-white p-8 rounded-2xl shadow-lg border border-gray-100" data-id="element-38">
            <p className="flex items-start gap-3" data-id="element-39">
              <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-1" data-id="element-40" />{' '}
              ¿Revisás el celular apenas despertás?
            </p>
            <p className="flex items-start gap-3" data-id="element-41">
              <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-1" data-id="element-42" />{' '}
              ¿Saltás de una app a otra sin darte cuenta?
            </p>
            <p className="flex items-start gap-3" data-id="element-43">
              <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-1" data-id="element-44" />{' '}
              ¿Te cuesta concentrarte más de unos minutos?
            </p>
            <p className="flex items-start gap-3" data-id="element-45">
              <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-1" data-id="element-46" />{' '}
              ¿Sentís ansiedad cuando no tenés el celular cerca?
            </p>
            <p className="flex items-start gap-3" data-id="element-47">
              <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-1" data-id="element-48" />{' '}
              ¿Terminás el día cansado pero sin haber hecho lo importante?
            </p>
          </div>

          <div className="mt-12 text-center text-xl md:text-2xl font-bold space-y-2" data-id="element-49">
            <p data-id="element-50">Si respondiste sí a varias de estas preguntas…</p>
            <p className="text-red-600 text-3xl mt-4" data-id="element-51">No es casualidad.</p>
            <p className="text-gray-800 mt-2" data-id="element-52">
              Tu cerebro está siendo entrenado por los algoritmos.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 3 - THE PROBLEM */}
      <section className="bg-black text-white py-20 px-4" data-id="element-53">
        <div className="max-w-4xl mx-auto text-center" data-id="element-54">
          <h2 className="text-4xl md:text-5xl font-black mb-12 text-purple-500" data-id="element-55">
            El problema que casi nadie reconoce
          </h2>

          <p className="text-xl md:text-2xl mb-8" data-id="element-56">
            Las aplicaciones modernas están diseñadas para capturar tu atención
            el mayor tiempo posible.
          </p>

          <p className="text-lg md:text-xl mb-4 text-gray-300" data-id="element-57">Cada:</p>
          <div className="flex flex-wrap justify-center gap-4 mb-8" data-id="element-58">
            <span className="bg-gray-800 px-4 py-2 rounded-lg font-bold text-purple-400" data-id="element-59">
              notificación
            </span>
            <span className="bg-gray-800 px-4 py-2 rounded-lg font-bold text-purple-400" data-id="element-60">
              video corto
            </span>
            <span className="bg-gray-800 px-4 py-2 rounded-lg font-bold text-purple-400" data-id="element-61">
              like
            </span>
            <span className="bg-gray-800 px-4 py-2 rounded-lg font-bold text-purple-400" data-id="element-62">
              mensaje
            </span>
          </div>

          <p className="text-xl md:text-2xl mb-4" data-id="element-63">
            activa un sistema muy específico en tu cerebro.
          </p>
          <p className="text-2xl md:text-3xl font-black text-purple-500 mb-8" data-id="element-64">
            El sistema de recompensa dopaminérgico.
          </p>
          <p className="text-lg md:text-xl mb-12 text-gray-400 italic" data-id="element-65">
            Ese mismo sistema está relacionado con las adicciones.
          </p>

          <p className="text-xl md:text-2xl mb-6 text-left max-w-2xl mx-auto" data-id="element-66">
            Por eso millones de personas sienten:
          </p>

          <ul className="text-lg md:text-xl space-y-4 text-left max-w-2xl mx-auto bg-gray-900 p-8 rounded-xl border border-gray-800" data-id="element-67">
            <li className="flex items-center gap-3" data-id="element-68">
              <CheckCircle2 className="text-purple-500 w-6 h-6 flex-shrink-0" data-id="element-69" />{' '}
              ansiedad constante
            </li>
            <li className="flex items-center gap-3" data-id="element-70">
              <CheckCircle2 className="text-purple-500 w-6 h-6 flex-shrink-0" data-id="element-71" />{' '}
              dificultad para concentrarse
            </li>
            <li className="flex items-center gap-3" data-id="element-72">
              <CheckCircle2 className="text-purple-500 w-6 h-6 flex-shrink-0" data-id="element-73" />{' '}
              fatiga mental
            </li>
            <li className="flex items-center gap-3" data-id="element-74">
              <CheckCircle2 className="text-purple-500 w-6 h-6 flex-shrink-0" data-id="element-75" />{' '}
              procrastinación
            </li>
            <li className="flex items-center gap-3" data-id="element-76">
              <CheckCircle2 className="text-purple-500 w-6 h-6 flex-shrink-0" data-id="element-77" />{' '}
              sensación de perder el control del tiempo
            </li>
          </ul>

          <div className="mt-12 text-2xl font-bold space-y-6" data-id="element-78">
            <p data-id="element-79">Pero el problema no es tu fuerza de voluntad.</p>
            <p className="text-purple-400 text-3xl" data-id="element-80">
              Tu cerebro simplemente está sobreestimulado.
            </p>
            <p className="text-gray-400" data-id="element-81">
              Y cuando el cerebro está sobreestimulado…
            </p>
            <p className="text-red-400" data-id="element-82">
              Pierde su capacidad natural de concentración.
            </p>
          </div>

          <div className="mt-16 bg-gray-900 p-8 rounded-2xl border border-purple-500/30" data-id="element-83">
            <h3 className="text-3xl font-black text-green-400 mb-4" data-id="element-84">
              La buena noticia
            </h3>
            <p className="text-xl mb-2" data-id="element-85">El cerebro puede recalibrarse.</p>
            <p className="text-xl mb-6" data-id="element-86">Y ese proceso tiene un nombre:</p>
            <p className="text-4xl md:text-5xl font-black text-purple-500" data-id="element-87">
              RESET DE DOPAMINA
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 4 - THE SOLUTION */}
      <section className="py-20 px-4 bg-white" data-id="element-88">
        <div className="max-w-5xl mx-auto text-center" data-id="element-89">
          <div className="inline-block bg-green-100 text-green-800 font-bold px-6 py-2 rounded-full text-xl mb-6" data-id="element-90">
            ✅ LA SOLUCIÓN
          </div>
          <h2 className="text-4xl md:text-5xl font-black mb-4 text-center" data-id="element-91">
            <span className="block" data-id="element-92">🧠 MEGA PACK</span>
            <span className="block text-purple-500" data-id="element-93">RESET DE DOPAMINA</span>
          </h2>
          <p className="text-xl md:text-2xl text-gray-600 mb-12" data-id="element-94">
            Un sistema estructurado diseñado para ayudarte a reprogramar tu
            relación con el celular en solo 14 días.
          </p>

          <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-6 mb-12" data-id="element-95">
            <div className="bg-gray-50 p-6 rounded-xl border border-gray-200 w-full md:w-1/4" data-id="element-96">
              <span className="text-4xl block mb-2" data-id="element-97">📂</span>
              <p className="font-bold" data-id="element-98">Accedés al Mega Pack</p>
            </div>
            <ChevronRight className="hidden md:block text-gray-400 w-8 h-8" data-id="element-99" />
            <div className="bg-gray-50 p-6 rounded-xl border border-gray-200 w-full md:w-1/4" data-id="element-100">
              <span className="text-4xl block mb-2" data-id="element-101">📘</span>
              <p className="font-bold" data-id="element-102">Implementás el contenido paso a paso</p>
            </div>
            <ChevronRight className="hidden md:block text-gray-400 w-8 h-8" data-id="element-103" />
            <div className="bg-gray-50 p-6 rounded-xl border border-gray-200 w-full md:w-1/4" data-id="element-104">
              <span className="text-4xl block mb-2" data-id="element-105">⚙</span>
              <p className="font-bold" data-id="element-106">Aplicás el proceso durante 14 días</p>
            </div>
            <ChevronRight className="hidden md:block text-gray-400 w-8 h-8" data-id="element-107" />
            <div className="bg-purple-50 p-6 rounded-xl border border-purple-200 w-full md:w-1/4 shadow-md" data-id="element-108">
              <span className="text-4xl block mb-2" data-id="element-109">🧠</span>
              <p className="font-bold text-purple-800" data-id="element-110">
                Recuperás claridad mental, enfoque y control
              </p>
            </div>
          </div>

          <div className="text-2xl font-bold text-gray-800 space-y-2" data-id="element-111">
            <p data-id="element-112">Sin eliminar la tecnología.</p>
            <p data-id="element-113">Sin disciplina extrema.</p>
            <p data-id="element-114">Sin métodos complicados.</p>
            <p className="text-3xl text-purple-600 mt-6 font-black" data-id="element-115">
              Solo un sistema claro para recuperar tu atención.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 5 - WHAT'S INCLUDED */}
      <section className="py-16 px-4 bg-gray-50 border-t border-gray-200" data-id="element-116">
        <div className="max-w-6xl mx-auto" data-id="element-117">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-6" data-id="element-118">
            📘 ¿Qué incluye exactamente el
            <span className="block text-4xl md:text-5xl mt-2 text-purple-500" data-id="element-119">
              MEGA PACK RESET DOPAMINA?
            </span>
          </h2>
          <p className="text-xl text-center text-gray-600 mb-12 font-medium" data-id="element-120">
            Un sistema dividido en 6 Tomos estratégicos + 3 Bonos especiales,
            organizados para implementación real.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-121">
            {/* Tomo 1 */}
            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-purple-500" data-id="element-122">
              <h3 className="text-2xl font-bold mb-2 text-gray-900" data-id="element-123">
                📘 TOMO 1
              </h3>
              <h4 className="text-xl font-bold text-purple-600 mb-4" data-id="element-124">
                El Cerebro Secuestrado
              </h4>
              <p className="text-gray-700 font-medium mb-4" data-id="element-125">
                Descubre cómo las redes sociales, apps y notificaciones
                manipulan tu cerebro.
              </p>
              <p className="font-bold text-gray-900 mb-2" data-id="element-126">Aprenderás:</p>
              <ul className="space-y-2 text-gray-700" data-id="element-127">
                <li className="flex items-start gap-2" data-id="element-128">
                  <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-129" />{' '}
                  cómo funciona la dopamina digital
                </li>
                <li className="flex items-start gap-2" data-id="element-130">
                  <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-131" />{' '}
                  por qué el celular genera dependencia
                </li>
                <li className="flex items-start gap-2" data-id="element-132">
                  <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-133" />{' '}
                  cómo los algoritmos capturan tu atención
                </li>
              </ul>
            </div>

            {/* Tomo 2 */}
            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-purple-500" data-id="element-134">
              <h3 className="text-2xl font-bold mb-2 text-gray-900" data-id="element-135">
                📘 TOMO 2
              </h3>
              <h4 className="text-xl font-bold text-purple-600 mb-4" data-id="element-136">
                Diagnóstico Digital
              </h4>
              <p className="text-gray-700 font-medium mb-4" data-id="element-137">
                Descubre cuánto tiempo estás perdiendo realmente con el celular.
              </p>
              <p className="font-bold text-gray-900 mb-2" data-id="element-138">Aprenderás a:</p>
              <ul className="space-y-2 text-gray-700" data-id="element-139">
                <li className="flex items-start gap-2" data-id="element-140">
                  <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-141" />{' '}
                  medir tu uso real
                </li>
                <li className="flex items-start gap-2" data-id="element-142">
                  <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-143" />{' '}
                  identificar apps adictivas
                </li>
                <li className="flex items-start gap-2" data-id="element-144">
                  <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-145" />{' '}
                  detectar detonadores digitales
                </li>
              </ul>
            </div>

            {/* Tomo 3 */}
            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-purple-500" data-id="element-146">
              <h3 className="text-2xl font-bold mb-2 text-gray-900" data-id="element-147">
                📘 TOMO 3
              </h3>
              <h4 className="text-xl font-bold text-purple-600 mb-4" data-id="element-148">
                Detox Digital
              </h4>
              <p className="text-gray-700 font-medium mb-4" data-id="element-149">
                La fase donde comienzas a reducir estímulos digitales.
              </p>
              <p className="font-bold text-gray-900 mb-2" data-id="element-150">
                Aplicarás técnicas para:
              </p>
              <ul className="space-y-2 text-gray-700" data-id="element-151">
                <li className="flex items-start gap-2" data-id="element-152">
                  <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-153" />{' '}
                  eliminar distracciones
                </li>
                <li className="flex items-start gap-2" data-id="element-154">
                  <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-155" />{' '}
                  reducir consumo automático
                </li>
                <li className="flex items-start gap-2" data-id="element-156">
                  <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-157" />{' '}
                  recuperar espacio mental
                </li>
              </ul>
            </div>

            {/* Tomo 4 */}
            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-purple-500" data-id="element-158">
              <h3 className="text-2xl font-bold mb-2 text-gray-900" data-id="element-159">
                📘 TOMO 4
              </h3>
              <h4 className="text-xl font-bold text-purple-600 mb-4" data-id="element-160">
                Reprogramación Mental
              </h4>
              <p className="text-gray-700 font-medium mb-4" data-id="element-161">
                Reconstruye tu capacidad natural de concentración.
              </p>
              <p className="font-bold text-gray-900 mb-2" data-id="element-162">Aprenderás:</p>
              <ul className="space-y-2 text-gray-700" data-id="element-163">
                <li className="flex items-start gap-2" data-id="element-164">
                  <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-165" />{' '}
                  entrenar enfoque profundo
                </li>
                <li className="flex items-start gap-2" data-id="element-166">
                  <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-167" />{' '}
                  reducir ansiedad digital
                </li>
                <li className="flex items-start gap-2" data-id="element-168">
                  <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-169" />{' '}
                  recuperar claridad mental
                </li>
              </ul>
            </div>

            {/* Tomo 5 */}
            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-purple-500" data-id="element-170">
              <h3 className="text-2xl font-bold mb-2 text-gray-900" data-id="element-171">
                📘 TOMO 5
              </h3>
              <h4 className="text-xl font-bold text-purple-600 mb-4" data-id="element-172">
                Recupera tu Atención
              </h4>
              <p className="text-gray-700 font-medium mb-4" data-id="element-173">
                Técnicas para volver a concentrarte durante períodos largos.
              </p>
              <p className="text-gray-700 italic" data-id="element-174">
                Una habilidad que millones de personas han perdido por el
                consumo constante de estímulos digitales.
              </p>
            </div>

            {/* Tomo 6 */}
            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-purple-500" data-id="element-175">
              <h3 className="text-2xl font-bold mb-2 text-gray-900" data-id="element-176">
                📘 TOMO 6
              </h3>
              <h4 className="text-xl font-bold text-purple-600 mb-4" data-id="element-177">
                Vida Después del Reset
              </h4>
              <p className="text-gray-700 font-medium mb-4" data-id="element-178">
                Cómo mantener tu libertad digital a largo plazo.
              </p>
              <p className="text-gray-700 italic" data-id="element-179">
                Convertirás este proceso en un estilo de vida donde la
                tecnología trabaja para vos y no al revés.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 6 - INSIDE LOOK (UPLOADED IMAGES) */}
      <section className="py-20 px-4 bg-white border-t border-gray-200" data-id="element-180">
        <div className="max-w-6xl mx-auto text-center" data-id="element-181">
          <h2 className="text-3xl md:text-4xl font-black mb-6 text-gray-900" data-id="element-182">
            👀 Mirá lo que vas a encontrar dentro del Mega Pack
          </h2>
          <p className="text-xl text-gray-600 mb-4 font-medium" data-id="element-183">
            A continuación podés ver ejemplos reales del contenido incluido.
          </p>
          <p className="text-lg text-gray-500 mb-12 italic" data-id="element-184">
            No es teoría: son herramientas diseñadas para aplicar directamente
            en tu vida.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-185">
            {['https://cdn.magicpatterns.com/uploads/kYmMP9uyMthm6CsCTigigU/Dopa-3_page-0001.jpg', 'https://cdn.magicpatterns.com/uploads/34coLXri54WAbuLmWXhyJQ/Dopa-8_page-0001.jpg', 'https://cdn.magicpatterns.com/uploads/9cUjr8c3GYqh4TnxQ8EBsD/Dopa-10_page-0001.jpg', 'https://cdn.magicpatterns.com/uploads/xk7JRXuB8MuLsoi6SSEdLF/Bono_2_dopamina-5_page-0001.jpg', 'https://cdn.magicpatterns.com/uploads/dx3wzWXAWqi5cYQUKsLpPH/Bono_3_dopamina-5_page-0001.jpg'].map((src, idx) => <a key={idx} href="#compra" className="block overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-shadow border border-gray-200" data-id="element-186">
                <img src={src} alt={`Preview ${idx + 1}`} className="w-full h-auto object-cover hover:scale-105 transition-transform duration-500" data-id="element-187" />
              </a>)}
          </div>
        </div>
      </section>

      {/* SECTION 7 - BONUSES */}
      <section className="py-20 px-4 bg-gray-900 text-white" data-id="element-188">
        <div className="max-w-6xl mx-auto" data-id="element-189">
          <div className="text-center mb-12" data-id="element-190">
            <h2 className="text-4xl md:text-5xl font-black mb-4 text-purple-400" data-id="element-191">
              🎁 REGALOS ESPECIALES
            </h2>
            <div className="inline-block bg-red-600 text-white font-black px-6 py-2 rounded-lg text-xl animate-pulse" data-id="element-192">
              Estos bonos están incluidos solo por tiempo limitado.
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-193">
            {/* Bono 1 */}
            <div className="bg-white text-gray-900 rounded-2xl overflow-hidden shadow-2xl flex flex-col p-8" data-id="element-194">
              <h4 className="text-xl font-black text-purple-600 mb-2" data-id="element-195">
                🎁 BONO 1
              </h4>
              <h5 className="text-2xl font-bold mb-4" data-id="element-196">
                Workbook Reset Dopamina
              </h5>
              <p className="text-gray-600 font-medium mb-6" data-id="element-197">
                Cuaderno práctico para acompañar el proceso de cambio.
              </p>
              <p className="font-bold mb-2" data-id="element-198">Incluye:</p>
              <ul className="space-y-3 font-medium flex-1" data-id="element-199">
                <li className="flex items-start gap-2" data-id="element-200">
                  <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-201" />{' '}
                  evaluación inicial
                </li>
                <li className="flex items-start gap-2" data-id="element-202">
                  <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-203" />{' '}
                  registro de hábitos digitales
                </li>
                <li className="flex items-start gap-2" data-id="element-204">
                  <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-205" />{' '}
                  seguimiento del progreso
                </li>
              </ul>
            </div>

            {/* Bono 2 */}
            <div className="bg-white text-gray-900 rounded-2xl overflow-hidden shadow-2xl flex flex-col p-8" data-id="element-206">
              <h4 className="text-xl font-black text-purple-600 mb-2" data-id="element-207">
                🎁 BONO 2
              </h4>
              <h5 className="text-2xl font-bold mb-4" data-id="element-208">
                Checklist Reset Dopamina
              </h5>
              <p className="text-gray-600 font-medium mb-6" data-id="element-209">
                Plan visual completo de los 14 días del programa.
              </p>
              <p className="font-bold mb-2" data-id="element-210">Incluye:</p>
              <ul className="space-y-3 font-medium flex-1" data-id="element-211">
                <li className="flex items-start gap-2" data-id="element-212">
                  <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-213" />{' '}
                  acciones diarias
                </li>
                <li className="flex items-start gap-2" data-id="element-214">
                  <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-215" />{' '}
                  seguimiento del progreso
                </li>
                <li className="flex items-start gap-2" data-id="element-216">
                  <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-217" />{' '}
                  estructura clara del método
                </li>
              </ul>
            </div>

            {/* Bono 3 */}
            <div className="bg-white text-gray-900 rounded-2xl overflow-hidden shadow-2xl flex flex-col p-8" data-id="element-218">
              <h4 className="text-xl font-black text-purple-600 mb-2" data-id="element-219">
                🎁 BONO 3
              </h4>
              <h5 className="text-2xl font-bold mb-4" data-id="element-220">
                Rutina Matutina Anti-Celular
              </h5>
              <p className="text-gray-600 font-medium mb-6" data-id="element-221">
                Protocolo de 20 minutos para empezar el día sin caer en la
                trampa del celular.
              </p>
              <p className="font-bold mb-2" data-id="element-222">Incluye:</p>
              <ul className="space-y-3 font-medium flex-1" data-id="element-223">
                <li className="flex items-start gap-2" data-id="element-224">
                  <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-225" />{' '}
                  activación mental
                </li>
                <li className="flex items-start gap-2" data-id="element-226">
                  <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-227" />{' '}
                  respiración consciente
                </li>
                <li className="flex items-start gap-2" data-id="element-228">
                  <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-229" />{' '}
                  claridad de objetivos
                </li>
                <li className="flex items-start gap-2" data-id="element-230">
                  <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-231" />{' '}
                  enfoque matutino
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 8 - BEFORE VS AFTER */}
      <section className="py-20 px-4 bg-gray-50" data-id="element-232">
        <div className="max-w-5xl mx-auto" data-id="element-233">
          <h2 className="text-4xl md:text-5xl font-black text-center mb-12" data-id="element-234">
            Antes vs Después
          </h2>

          <div className="flex flex-col md:flex-row gap-8 mb-12" data-id="element-235">
            <div className="flex-1 bg-red-50 p-8 rounded-2xl border border-red-100" data-id="element-236">
              <h3 className="text-2xl font-bold text-red-800 mb-6 text-center border-b border-red-200 pb-4" data-id="element-237">
                Antes del Reset Dopamina
              </h3>
              <ul className="space-y-4 text-lg font-medium text-red-900" data-id="element-238">
                <li className="flex items-start gap-3" data-id="element-239">
                  <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-240" />{' '}
                  revisás el celular constantemente
                </li>
                <li className="flex items-start gap-3" data-id="element-241">
                  <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-242" />{' '}
                  te cuesta concentrarte
                </li>
                <li className="flex items-start gap-3" data-id="element-243">
                  <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-244" />{' '}
                  saltás entre apps
                </li>
                <li className="flex items-start gap-3" data-id="element-245">
                  <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-246" />{' '}
                  ansiedad digital
                </li>
                <li className="flex items-start gap-3" data-id="element-247">
                  <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-248" />{' '}
                  perdés horas sin darte cuenta
                </li>
              </ul>
            </div>

            <div className="flex-1 bg-green-50 p-8 rounded-2xl border border-green-200 shadow-xl transform md:-translate-y-4" data-id="element-249">
              <h3 className="text-2xl font-bold text-green-800 mb-6 text-center border-b border-green-200 pb-4" data-id="element-250">
                Después del Reset
              </h3>
              <ul className="space-y-4 text-lg font-medium text-green-900" data-id="element-251">
                <li className="flex items-start gap-3" data-id="element-252">
                  <CheckCircle2 className="text-green-600 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-253" />{' '}
                  recuperás tu concentración
                </li>
                <li className="flex items-start gap-3" data-id="element-254">
                  <CheckCircle2 className="text-green-600 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-255" />{' '}
                  tu mente se siente más clara
                </li>
                <li className="flex items-start gap-3" data-id="element-256">
                  <CheckCircle2 className="text-green-600 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-257" />{' '}
                  reducís ansiedad digital
                </li>
                <li className="flex items-start gap-3" data-id="element-258">
                  <CheckCircle2 className="text-green-600 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-259" />{' '}
                  dormís mejor
                </li>
                <li className="flex items-start gap-3" data-id="element-260">
                  <CheckCircle2 className="text-green-600 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-261" />{' '}
                  recuperás tiempo real de tu día
                </li>
              </ul>
            </div>
          </div>

          <div className="text-center mb-12" data-id="element-262">
            <p className="text-2xl font-bold text-gray-600" data-id="element-263">
              No se trata de usar menos tecnología.
            </p>
            <p className="text-3xl font-black text-purple-600 mt-2" data-id="element-264">
              Se trata de volver a tener control sobre tu mente.
            </p>
          </div>

          <CTAButton text="👉 QUIERO EMPEZAR MI RESET AHORA" data-id="element-265" />
        </div>
      </section>

      {/* SECTION 9 - PURCHASE SECTION / PRICING */}
      <section id="compra" className="py-20 px-4 bg-white border-t border-gray-200" data-id="element-266">
        <div className="max-w-4xl mx-auto bg-purple-50 rounded-3xl p-8 md:p-12 border-4 border-purple-400 shadow-2xl relative" data-id="element-267">
          <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-8 py-3 rounded-full font-black md:text-2xl shadow-lg whitespace-nowrap text-[18px] animate-pulse" data-id="element-268">
            ⏰ Acceso disponible por tiempo limitado
          </div>

          <div className="mt-10 mb-10 text-center" data-id="element-269">
            <h3 className="text-3xl md:text-4xl font-black text-gray-900 mb-8" data-id="element-270">
              💰 Valor del sistema RESET DOPAMINA
            </h3>

            <div className="max-w-lg mx-auto bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-purple-100 mb-10 text-left space-y-4" data-id="element-271">
              <div className="flex justify-between items-center border-b border-gray-100 pb-3" data-id="element-272">
                <span className="font-semibold text-gray-700 text-lg" data-id="element-273">
                  📘 Tomo 1 – El Cerebro Secuestrado
                </span>
                <span className="font-bold text-gray-900 text-lg" data-id="element-274">$12.000</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-3" data-id="element-275">
                <span className="font-semibold text-gray-700 text-lg" data-id="element-276">
                  📘 Tomo 2 – Diagnóstico Digital
                </span>
                <span className="font-bold text-gray-900 text-lg" data-id="element-277">$10.000</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-3" data-id="element-278">
                <span className="font-semibold text-gray-700 text-lg" data-id="element-279">
                  📘 Tomo 3 – Detox Digital
                </span>
                <span className="font-bold text-gray-900 text-lg" data-id="element-280">$10.000</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-3" data-id="element-281">
                <span className="font-semibold text-gray-700 text-lg" data-id="element-282">
                  📘 Tomo 4 – Reprogramación Mental
                </span>
                <span className="font-bold text-gray-900 text-lg" data-id="element-283">$9.000</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-3" data-id="element-284">
                <span className="font-semibold text-gray-700 text-lg" data-id="element-285">
                  📘 Tomo 5 – Recuperar tu Atención
                </span>
                <span className="font-bold text-gray-900 text-lg" data-id="element-286">$9.000</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-3" data-id="element-287">
                <span className="font-semibold text-gray-700 text-lg" data-id="element-288">
                  📘 Tomo 6 – Vida Después del Reset
                </span>
                <span className="font-bold text-gray-900 text-lg" data-id="element-289">$8.000</span>
              </div>
              <div className="flex justify-between items-center pt-3" data-id="element-290">
                <span className="font-bold text-purple-600 text-lg" data-id="element-291">
                  🎁 Bonos especiales incluidos
                </span>
                <span className="font-bold text-purple-600 text-lg" data-id="element-292">
                  $22.000
                </span>
              </div>
            </div>

            <div className="mb-10" data-id="element-293">
              <p className="text-xl md:text-2xl text-gray-500 font-bold mb-1" data-id="element-294">
                Valor total del sistema
              </p>
              <p className="text-3xl md:text-4xl text-gray-400 font-bold line-through mb-6" data-id="element-295">
                $80.000
              </p>
              <p className="text-2xl md:text-3xl font-black text-gray-900 mb-4" data-id="element-296">
                HOY SOLO:
              </p>
              <div className="inline-block bg-white rounded-2xl px-12 py-6 border-4 border-purple-500 shadow-xl" data-id="element-297">
                <p className="text-6xl md:text-7xl lg:text-8xl font-black text-purple-600" data-id="element-298">
                  $9.990
                </p>
              </div>
              <p className="mt-6 font-bold text-green-600 text-xl" data-id="element-299">
                Acceso inmediato al sistema completo.
              </p>
            </div>
          </div>

          <CTAButton text="👉 SÍ, QUIERO ACCEDER AL SISTEMA AHORA" href={PURCHASE_LINK} isExternal={true} className="text-2xl md:text-3xl py-6" data-id="element-300" />

          <div className="text-center mt-4 mb-10 text-sm text-gray-500 font-medium flex items-center justify-center gap-1" data-id="element-301">
            <Lock className="w-4 h-4" data-id="element-302" /> Pago 100% seguro.
          </div>

          {/* Guarantee */}
          <div className="bg-white p-8 rounded-xl border border-gray-200 text-center mt-8 shadow-sm" data-id="element-303">
            <div className="flex justify-center mb-4" data-id="element-304">
              <ShieldCheck className="w-16 h-16 text-green-500" data-id="element-305" />
            </div>
            <h4 className="text-2xl font-black mb-4 flex items-center justify-center gap-2" data-id="element-306">
              Garantía sin riesgo
            </h4>
            <p className="text-gray-700 font-medium mb-2 text-lg" data-id="element-307">
              Implementa el sistema durante los primeros días.
            </p>
            <p className="text-gray-700 font-medium mb-6 text-lg" data-id="element-308">
              Si no sientes mayor claridad mental y control sobre tu uso del
              celular, puedes solicitar reembolso.
            </p>
            <p className="text-gray-900 font-bold text-xl" data-id="element-309">
              Porque el problema no es tu disciplina. Es la dopamina digital.
            </p>
            <p className="text-purple-600 font-bold mt-2 text-xl" data-id="element-310">
              Y eso es exactamente lo que este sistema te ayuda a recalibrar.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 10 - WHO IS THIS FOR */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-311">
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-312">
          <div className="bg-white p-8 rounded-2xl shadow-md border-t-4 border-green-500" data-id="element-313">
            <h3 className="text-2xl font-black mb-6 text-gray-900" data-id="element-314">
              💡 ¿Para quién es?
            </h3>
            <ul className="space-y-4 font-medium text-lg" data-id="element-315">
              <li className="flex items-start gap-3" data-id="element-316">
                <CheckCircle2 className="text-green-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-317" />{' '}
                personas que sienten que usan demasiado el celular
              </li>
              <li className="flex items-start gap-3" data-id="element-318">
                <CheckCircle2 className="text-green-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-319" />{' '}
                estudiantes que quieren recuperar concentración
              </li>
              <li className="flex items-start gap-3" data-id="element-320">
                <CheckCircle2 className="text-green-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-321" />{' '}
                profesionales que quieren más productividad
              </li>
              <li className="flex items-start gap-3" data-id="element-322">
                <CheckCircle2 className="text-green-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-323" />{' '}
                personas con ansiedad digital
              </li>
            </ul>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-md border-t-4 border-red-500" data-id="element-324">
            <h3 className="text-2xl font-black mb-6 text-gray-900" data-id="element-325">
              🚫 ¿Para quién NO es?
            </h3>
            <ul className="space-y-4 font-medium text-lg" data-id="element-326">
              <li className="flex items-start gap-3" data-id="element-327">
                <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-328" />{' '}
                para quien no quiere cambiar su relación con la tecnología
              </li>
              <li className="flex items-start gap-3" data-id="element-329">
                <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-330" />{' '}
                para quien busca soluciones mágicas sin aplicar el método
              </li>
              <li className="flex items-start gap-3" data-id="element-331">
                <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-332" />{' '}
                para quien no quiere dedicar 14 días a mejorar su mente
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* SECTION 11 - WHAT YOU'RE REALLY BUYING */}
      <section className="py-20 px-4 bg-black text-white text-center" data-id="element-333">
        <div className="max-w-4xl mx-auto" data-id="element-334">
          <h2 className="text-4xl md:text-5xl font-black mb-8 text-purple-500" data-id="element-335">
            📈 Lo que realmente estás comprando
          </h2>
          <p className="text-2xl font-bold mb-10 text-gray-300" data-id="element-336">
            No son solo ebooks.
          </p>
          <p className="text-xl mb-8" data-id="element-337">Estás comprando:</p>

          <ul className="text-2xl md:text-3xl font-black space-y-6 text-purple-400 text-left max-w-2xl mx-auto" data-id="element-338">
            <li className="flex items-start gap-4" data-id="element-339">
              <CheckCircle2 className="w-8 h-8 flex-shrink-0 mt-1" data-id="element-340" /> un sistema
              para recuperar tu atención
            </li>
            <li className="flex items-start gap-4" data-id="element-341">
              <CheckCircle2 className="w-8 h-8 flex-shrink-0 mt-1" data-id="element-342" /> un método
              para reducir ansiedad digital
            </li>
            <li className="flex items-start gap-4" data-id="element-343">
              <CheckCircle2 className="w-8 h-8 flex-shrink-0 mt-1" data-id="element-344" /> una
              estructura para mejorar tu concentración
            </li>
            <li className="flex items-start gap-4" data-id="element-345">
              <CheckCircle2 className="w-8 h-8 flex-shrink-0 mt-1" data-id="element-346" /> un proceso
              para recuperar tiempo y claridad mental
            </li>
          </ul>
        </div>
      </section>

      {/* SECTION 12 - FINAL CTA */}
      <section className="py-24 px-4 bg-white text-center" data-id="element-347">
        <div className="max-w-4xl mx-auto" data-id="element-348">
          <h2 className="text-5xl md:text-6xl font-black mb-6 text-center" data-id="element-349">
            <span className="block" data-id="element-350">🧠 MEGA PACK</span>
            <span className="block text-purple-500" data-id="element-351">RESET DE DOPAMINA</span>
          </h2>
          <p className="text-2xl md:text-3xl font-bold text-gray-600 mb-12" data-id="element-352">
            El sistema práctico para romper la adicción digital, recuperar tu
            enfoque y volver a tener control sobre tu mente.
          </p>

          <div className="text-3xl md:text-4xl font-black text-purple-600 space-y-6 mb-16" data-id="element-353">
            <p data-id="element-354">
              👉 Es momento de dejar de entregar tu atención a los algoritmos.
            </p>
            <p data-id="element-355">👉 Es momento de recuperar tu mente.</p>
          </div>

          <CTAButton text="🚀 SÍ, QUIERO EMPEZAR MI RESET AHORA" href={PURCHASE_LINK} isExternal={true} className="text-2xl md:text-3xl py-6" data-id="element-356" />
          <p className="mt-8 text-2xl font-black text-gray-800" data-id="element-357">
            Rompe la adicción al celular. Recupera tu enfoque. Recupera tu vida.
          </p>
        </div>
      </section>
    </div>;
}